// extracted by mini-css-extract-plugin
export default {"TabBar":"style_TabBar__E-qP0","tabs":"style_tabs__VWUxl","tab":"style_tab__9o9Xw","icon":"style_icon__EXQGx","highlight":"style_highlight__vSDBV","selected":"style_selected__j0C5E"};